import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { convertPrice } from '~/utils'

// Component dùng chung hiển thị giá gốc và giá khuyến mãi của món ăn
const FoodPrice = ({ price = 0, original_price = 0, discount_amount = 0 }) => {
  // Hiển thị giá gốc. Nếu trong trường hợp không giảm giá(discount_amount) -> không hiển thị giá này
  const renderOriginalPrice = () => {
    if (!discount_amount) return null

    return (
      <Box
        marginTop="1px"
        lineHeight="1.2"
        fontSize="1rem"
        fontWeight="400"
        color="baseColor.colorText1"
        sx={{ textDecoration: 'line-through' }}>
        {convertPrice(original_price)}
      </Box>
    )
  }

  // Hiển thị giá khuyến mãi = giá gốc(original_price) - tiền được giảm (discount_amount)
  const renderPromotionalPrice = () => {
    return (
      <Box
        fontSize="1.4rem"
        lineHeight="1.225"
        fontWeight="600"
        color={discount_amount ? 'baseColor.colorText7' : 'baseColor.colorText1'}>
        {convertPrice(price)}
      </Box>
    )
  }

  return (
    <Box display="flex" flexWrap="wrap-reverse" alignItems="center" columnGap="4px" mt="4px">
      {renderPromotionalPrice()}
      {renderOriginalPrice()}
    </Box>
  )
}

FoodPrice.propTypes = {
  price: PropTypes.number,
  original_price: PropTypes.number,
  discount_amount: PropTypes.number,
}

export default React.memo(FoodPrice)
